import { ArrowUpRight, MapPin } from 'lucide-react';
import { associationAddress } from '../contactData';
import '../styles/footer-contacts.css';

export const FooterContacts = () => <div className="footer-contacts" data-testid="footer-contacts">
  <div className="footer-address-area">
    <span className="eyebrow" data-testid="footer-address-label"><MapPin size={15} />INDIRIZZO PUBBLICO</span>
    <address data-testid="association-address"><strong>{associationAddress.street}</strong><span>{associationAddress.locality}</span></address>
    <a href={associationAddress.mapsUrl} target="_blank" rel="noopener" className="text-link" data-testid="association-map-link">Apri in Google Maps <ArrowUpRight size={17} /></a>
    <p className="footer-address-note" data-testid="association-address-note">Indirizzo riportato nell’elenco pubblico. Contatta l’associazione prima di una visita.</p>
    <a href={associationAddress.source} target="_blank" rel="noopener" className="footer-source-link" data-testid="association-address-source">Verifica la fonte dell’indirizzo <ArrowUpRight size={13} /></a>
  </div>
  <div className="footer-map-area">
    <iframe className="footer-map" src={associationAddress.embedUrl} title="Mappa di Via Manin 13, Cento (FE)" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-testid="association-map-embed" />
  </div>
</div>;
